// Code review - In Progress
// Documentation - In Progress
import React, { useState } from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
const CityPopup = ({ data, countryOptions, stateOptions }) => {
  const selectedCountry = countryOptions.find(
    (item) => item.value === data?.MstCountryId
  );
  const selectedState = stateOptions.find(
    (item) => item.value === data?.MstStateId
  );
  return (
    <div class="w-full ">
      <div class="mx-auto  lg:w-2/5 flex justify-center md:w-full w-full border-black">
        <div class="relative w-full h-full max-w-xl md:h-auto">
          <div class="relative bg-white rounded-lg shadow ">
            <div class="px-6 py-6 lg:px-8">
              <form class="space-y-6" action="#">
                <AutoDropDown
                 
                  title={"Country"}
                  options={[]}
                  placeholder={"Select"}
                  name={"country"}
                  selectedOption={selectedCountry}
                  Class="custom-class"
                  disabled={true}
                />
                <AutoDropDown
                  title="State"
                  options={[]}
                  placeholder="Select"
                  name="state"
                  
                   selectedOption={selectedState}
                  Class="custom-class"
                  classStar="text-red-500"
                  disabled={true}
                  
                  
                  
                  
                />

                <InputText
                  inputType={"text"}
                  title={"City"}
                  name={"branchProjec"}
                  
                  classStar="text-red-500"
                  disabled={true}
                  content={data?.City}
                />
                <InputText
                  inputType={"text"}
                  title={"City Code"}
                  name={"branchProjectCode"}
                  
                  classStar="text-red-500"
                  disabled={true}
                  content={data?.CityCode}
                />
                
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CityPopup;
